<script setup>
import { ref, watch } from 'vue';
import {zutil} from '@assets/scripts/zutil';

const props = defineProps({
  progress: {
    type: Boolean,
    default: false,
  },
  showLogo: {
    type: Boolean,
    default: true,
  },
  showBg: {
    type: Boolean,
    default: true,
  },
});

// let percentage = 0

watch(
  () => props.progress,
  (val) => {
    if (val) {
      startTimer();
    }
  },
  { immediate: true }
);

let count = ref(0);

function startTimer() {
  const intervalId = setInterval(() => {
    // const randomIncrease = Math.floor(Math.random() * 10);
    // count.value += randomIncrease;
    count.value += 10;
    if (count.value >= 90) {
      clearInterval(intervalId);
    }
  }, 1000);
}

//  :style="Xmas_view_style()"
//  class="skeleton-block-Xmas"
function Xmas_view_style() {
    let style = {
      position: 'fixed',
      left: '0',
      top: '0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      background: "url('" + zutil.getImage('XmasLoading_bg') + "') no-repeat center center !important",
      backgroundSize: '100% 100%',
      zIndex: '99999999',
    };
    window.log("[Skeleton] Xmas_view_style props.showBg",props.showBg)
    if(!props.showBg){
      style.background = '';
      style.backgroundSize = '';
    }
    return style;
}
</script>
<template>
  <view :style="Xmas_view_style()" v-if="zutil.getActivityType() == 1">
    <image style="width: 300rpx;" mode="widthFix" :src="zutil.getImage('logo_2')" v-show="showLogo"></image>
    <image style="width: 240rpx;height: 150rpx;margin: 5rpx 0 0rpx;" :src="zutil.getImage('XmasLoading_gif')" v-show="showLogo"></image>
    <view style="width: 240rpx;height: 260rpx;"></view>
    <up-line-progress :percentage="count" :activeColor="`var(--main-clr)`" v-show="progress"></up-line-progress>
  </view>
  <view class="skeleton-block" v-else="zutil.getActivityType() == 0">
    <image class="logo" src="@imgs/logo_2.png" v-show="showLogo"></image>
    <image class="skeleton-logo" src="@imgCom/common/loading.gif"></image>
    <up-line-progress :percentage="count" :activeColor="`var(--main-clr)`" v-show="progress"></up-line-progress>
  </view>
</template>
<style lang="scss" scoped>
.skeleton-block {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: var(--page-bg) !important;
  z-index: 99999999;

  .logo {
    width: 236rpx;
    height: 58rpx;
    margin-bottom: 60rpx;
  }

  .skeleton-logo {
    height: 190rpx;
    width: 200rpx;
    // margin-top: -5vh;
  }
}

:deep(.u-line-progress) {
  width: 50%;
  border-radius: 0;
  flex: none;
  margin-top: 50rpx;

  .u-line-progress__text {
    color: black;
    margin-top: 2rpx;

    span {
      font-size: 30rpx;
      font-weight: bold;
    }
  }
}

// .skeleton-block-Xmas {
//   position: fixed;
//   left: 0;
//   top: 0;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   height: 100vh;
//   width: 100vw;
//   overflow: hidden;
//   background: url('@imgCom/activity/XmasUI/XmasLoading_bg.webp') no-repeat center center !important;
//   background-size: contain !important;           /* 保持比例，完整显示，不裁剪 */
//   z-index: 99999999;
// }
</style>
